import { settlementTexts } from 'consts/text';
import { AppTable } from 'components/organisms';
import { ChildBillBaseComponent } from 'types';
import { ChildBillAdditionalComponentListDisplay } from 'components/templates/settlement/ChildrenBillPartsTable/components';
import { useCallback, useMemo } from 'react';
import { useIsMobile } from 'hooks/useIsMobile/useIsMobile';
import { columnsPostpaid } from './ChildrenBillComponentsTable.helpers';
import { ChildrenBillAdditionalRightTableHeaderComponent } from './components/ChildrenBillAdditionalRightTableHeaderComponent/ChildrenBillAdditionalRightTableHeaderComponent';

export type ChildrenBillComponentsTableProps = {
    title?: string;
    diff?: number;
    isExpanded?: boolean;
    onExpand?: () => void;
    summary: number;
    billComponents: ChildBillBaseComponent[] | null;
    additionalLeftTableHeaderContent?: React.ReactNode;
};

export const ChildrenBillComponentsTable = ({
    title,
    summary,
    diff,
    isExpanded,
    onExpand,
    billComponents,
    additionalLeftTableHeaderContent,
}: ChildrenBillComponentsTableProps) => {
    const isMobile = useIsMobile();

    const expandedRowRender = useCallback(
        (childBillBaseComponent: ChildBillBaseComponent) => (
            <ChildBillAdditionalComponentListDisplay
                isPrepaid={false}
                childBillAdditionalComponents={childBillBaseComponent.additionalComponents}
            />
        ),
        [],
    );

    const expandable = useMemo(
        () =>
            !isMobile
                ? {
                      expandedRowRender,
                      showExpandColumn: true,
                  }
                : undefined,
        [isMobile, expandedRowRender],
    );

    return (
        <AppTable<ChildBillBaseComponent>
            isTableManageUtilsHidden
            additionalRightTableHeaderContent={
                <ChildrenBillAdditionalRightTableHeaderComponent
                    diff={diff}
                    summary={summary}
                    isExpanded={isExpanded}
                    onExpand={onExpand}
                />
            }
            additionalLeftTableHeaderContent={additionalLeftTableHeaderContent}
            title={title ?? settlementTexts.children.details.billComponents}
            emptyInfo={settlementTexts.children.details.billComponentsEmpty}
            columns={columnsPostpaid}
            rowKey={({ id }) => id}
            dataSource={billComponents ?? undefined}
            isDataHidden={isExpanded === false}
            expandable={expandable}
        />
    );
};
